import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  TableProps,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import * as React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { IoArrowDown } from "react-icons/io5";
import { members } from "./data";
import {
  KYDAdminEvent,
  KYDEvent,
  KYDEventStatus,
} from "@common/interfaces/KYDEvent";
import { Navigate, useNavigate } from "react-router-dom";

export const MemberTable = ({ events, ...props }: { events: KYDEvent[] }) => {
  const navigate = useNavigate();

  const badgeForStatus = (status: KYDEventStatus) => {
    let bg = "gray";
    let name = "N/A";

    switch (status) {
      case "DRAFT":
        bg = "blue";
        name = "Draft";

        break;
      case "PENDING_APPROVAL":
        bg = "yellow";
        name = "Pending Approval";

        break;
      case "OPEN":
        bg = "green";
        name = "On Sale";

        break;
      case "OFFSALE":
        bg = "red";
        name = "Off Sale";

        break;
      default: {
      }
    }

    return (
      <Badge justifyItems={"center"} colorScheme={bg}>
        {name}
      </Badge>
    );
  };

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Event</Th>
          <Th>Status</Th>
          <Th>Date</Th>
          <Th>Venue</Th>
          <Th>Sales / Tickets</Th>
        </Tr>
      </Thead>
      <Tbody>
        {events.map((member: KYDAdminEvent) => (
          <Tr
            onClick={() => navigate(`/manager/events/${member.id}`)}
            style={{ cursor: "pointer" }}
            key={member.id}
          >
            <Td>
              <HStack spacing="3">
                <Box>
                  <Text fontWeight="medium">{member.name}</Text>
                </Box>
              </HStack>
            </Td>
            <Td>{badgeForStatus(member.status)}</Td>
            <Td>
              <Text color="muted">{member.display_start_at}</Text>
            </Td>
            <Td>
              <Text color="muted">{member.venues[0].name}</Text>
            </Td>
            <Td>
              <HStack>
                <Text>{member.total_gmv_display}</Text>
                <Text>/</Text>
                <Text>{member.total_tickets_purchased}</Text>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
